// components/PrivateRoute.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { useUserStore } from '../utils/userStore';
import { RouterConstant } from './index';

const PrivateRoute = () => {
  const isAuthenticated = useUserStore((state) => state.isAuthenticated);
  const { ROUTERS_PATH } = RouterConstant;

  if (!isAuthenticated()) {
    return <Navigate to={ROUTERS_PATH.USERREGISTRATIONINITIAL} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
